import { formatCalendarDay, parseDateOnly, weekdayNarrow } from '@voll-intelligence/dates';

/** As iniciais da semana, domingo primeiro ("D S T Q Q S S"), da tabela do
 *  módulo de datas — a mesma do calendário do kit. */
export function weekdayInitials(locale: string): string[] {
  // 2023-01-01 é um domingo.
  return Array.from({ length: 7 }, (_, i) => weekdayNarrow(new Date(2023, 0, 1 + i), locale));
}

/**
 * Nome acessível de um dia da grade — "15 de setembro" (pt-BR/es) ou
 * "September 15" (en). Era "15/09": sem o mês por extenso o leitor de tela
 * soletrava uma fração (#3239 C6). Sem ano de propósito: a grade já anuncia o
 * mês/ano no título, e o dia é lido dentro dela.
 */
export function fmtCalendarDayLabel(iso: string, locale: string): string {
  const date = parseDateOnly(iso);
  return date ? formatCalendarDay(date, locale) : '';
}
